import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OrderShuttleVM } from '../../../../../models/orderModel';
import { OrderShuttleService } from '../../../../../services/ordershuttle.service';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-arrivaldeparture-details',
  templateUrl: './arrivaldeparture-details.component.html',
  styleUrls: ['./arrivaldeparture-details.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ArrivalDepartureDetailsComponent implements OnInit, OnDestroy {
  arrivalId: string;
  departureId: string;
  arrivalDepartureHeader: string;
  orderShuttlesVM: OrderShuttleVM[] = [];
  componentDestroyed$: Subject<boolean> = new Subject();
  displayedColumnsOrders: string[] = [
    'orderNr',
    'firstName',
    'cellular',
    'email',
    'passengers',
    'childseats',
    'baggage'
  ];
  displayFlightColumns: string[] = [];
  isLoading: boolean = false;
  activeRequests: number = 0;
  emptyData = new MatTableDataSource([{ empty: "row" }]);

  constructor(
    @Inject(MAT_DIALOG_DATA) public arrivalDeparture: any,
    public snackBar: MatSnackBar,
    public orderShuttleService: OrderShuttleService,
    public router: Router
  ) { }

  ngOnInit(): void {

    this.arrivalId = this.arrivalDeparture.arrivalId;
    this.departureId = this.arrivalDeparture.departureId;


    if (this.arrivalId != null) {
      if (this.arrivalDeparture.isShuttles > 0) this.getArrivals(this.arrivalId);
      this.arrivalDepartureHeader = "Arrivals";
      this.displayFlightColumns = [
        'stationName',
        'terminalName',
        'arrivalCode',
        'operator',
        'scheduledArrival',
        'estimatedArrival',
        'actualArrival',
        'flightDepartureDate',
        'status',
        'remarks',
        'departureStation',
        'gate',
        // 'firstBagEstimated',
        'firstBag',
        'lastBag',
        'baggageClaimUnit',
        'updated',
        'orderShuttles'
      ];
    }

    if (this.departureId != null) {
      if (this.arrivalDeparture.isShuttles > 0) this.getDepartures(this.departureId);
      this.arrivalDepartureHeader = "Departures";
      this.displayFlightColumns = [
        'stationName',
        'terminalName',
        'departureCode',
        'operator',
        'scheduledDeparture',
        'estimatedDeparture',
        'actualDeparture',
        'flightDepartureDate',
        'status',
        'remarks',
        'arrivalStation',
        'gate',
        'checkInStatus',
        'checkInDeskFrom',
        'checkInDeskTo',
        'updated',
        'orderShuttles'
      ];
    }

  }

  setLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }

  incrementActiveRequests() {
    this.activeRequests++;
    if (this.activeRequests === 1) {
      this.setLoading(true);
    }
  }

  decrementActiveRequests() {
    if (this.activeRequests > 0) {
      this.activeRequests--;
    }
    if (this.activeRequests === 0) {
      this.setLoading(false);
    }
  }

  getArrivals(arrivalId: string) {
    this.incrementActiveRequests();
    this.orderShuttleService
      .getOrderShuttlesArrival(arrivalId)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(orderShuttles => {
        this.orderShuttlesVM = orderShuttles;
        this.decrementActiveRequests();
      });
  }

  getDepartures(departureId: string) {
    this.incrementActiveRequests();
    this.orderShuttleService
      .getOrderShuttlesDeparture(departureId)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(orderShuttles => {
        this.orderShuttlesVM = orderShuttles;
        this.decrementActiveRequests();
      });
  }

  goToOrder(orderId: string): void {
    if(orderId){
      const url = this.router.serializeUrl(this.router.createUrlTree([`/admin/back-office24-order/${orderId}`]));
      window.open(url, '_blank');
    }
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
